"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OperationExplainedBox = void 0;
const tslib_1 = require("tslib");
const css_1 = require("@emotion/css");
const react_1 = tslib_1.__importDefault(require("react"));
const data_1 = require("@grafana/data");
const ui_1 = require("@grafana/ui");
function OperationExplainedBox({ title, stepNumber, markdown, children }) {
    const styles = (0, ui_1.useStyles2)(getStyles);
    return (react_1.default.createElement("div", { className: styles.box },
        stepNumber !== undefined && react_1.default.createElement("div", { className: styles.stepNumber }, stepNumber),
        react_1.default.createElement("div", { className: styles.boxInner },
            title && (react_1.default.createElement("div", { className: styles.header },
                react_1.default.createElement("span", null, title))),
            react_1.default.createElement("div", { className: styles.body },
                markdown && react_1.default.createElement("div", { dangerouslySetInnerHTML: { __html: (0, data_1.renderMarkdown)(markdown) } }),
                children))));
}
exports.OperationExplainedBox = OperationExplainedBox;
const getStyles = (theme) => {
    return {
        box: (0, css_1.css)({
            background: theme.colors.background.secondary,
            padding: theme.spacing(1),
            borderRadius: theme.shape.radius.default,
            position: 'relative',
        }),
        boxInner: (0, css_1.css)({
            marginLeft: theme.spacing(4),
        }),
        stepNumber: (0, css_1.css)({
            fontWeight: theme.typography.fontWeightMedium,
            background: theme.colors.secondary.main,
            width: '20px',
            height: '20px',
            borderRadius: theme.shape.radius.circle,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'absolute',
            top: '10px',
            left: '11px',
            fontSize: theme.typography.bodySmall.fontSize,
        }),
        header: (0, css_1.css)({
            paddingBottom: theme.spacing(0.5),
            display: 'flex',
            alignItems: 'center',
            fontFamily: theme.typography.fontFamilyMonospace,
        }),
        body: (0, css_1.css)({
            color: theme.colors.text.secondary,
            'p:last-child': {
                margin: 0,
            },
            a: {
                color: theme.colors.text.link,
                textDecoration: 'underline',
            },
        }),
    };
};
//# sourceMappingURL=OperationExplainedBox.js.map